import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TrustedBy from "@/components/landing/TrustedBy";
import Solutions from "@/components/landing/Solutions";
import Benefits from "@/components/landing/Benefits";
import Calculator from "@/components/landing/Calculator";
import HowItWorks from "@/components/landing/HowItWorks";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import Floating from "@/components/landing/Floating";

const LandingPage = () => (
  <div className="relative bg-white overflow-x-hidden" data-testid="landing-page">
    <Navbar />
    <main>
      <Hero />
      <TrustedBy />
      <Solutions />
      <Benefits />
      <HowItWorks />
      <WhyChooseUs />
      <FAQ />
      <FinalCTA />
    </main>
    <Footer />
    <Floating />
  </div>
);

export default LandingPage;
